function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 411 411",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.995.095h410v410h-410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.786 210.34-40.675-40.675-27.904-27.876-7.78-7.779c-7.637-7.638-19.243-10.098-29.34-6.002l-65.536 27.164v85.59h7.111a72.13 72.13 0 0 1 48.455 18.702l31.502 28.586c7.41 7.197 19.228 7.112 26.539-.184l.185-.185c7.352-7.353 7.367-19.271.042-26.653l3.342 3.342c7.382 7.382 19.343 7.382 26.724 0 7.381-7.381 7.381-19.342 0-26.723l-13.909-13.909h.014l13.938 13.937c7.395 7.396 19.342 7.396 26.737 0l.569-.569c7.239-7.424 7.239-19.37-.014-26.766Z",
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.439 150.493-77.141-31.545a26.927 26.927 0 0 0-22.428.782l-47.019 23.538c-11.065 5.547-13.454 20.295-4.708 29.042a18.14 18.14 0 0 0 20.992 3.371l41.771-21.049-21.831 22.997 32.711 32.711v26.738l31.517 8.292 20.579-4.623 25.557-17.066v-73.188ZM330.439 131.834h35.556v120.889h-35.556z",
    style: {
      fill: "#f3f3f1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    },
    d: "M45.995 131.834h35.556v120.889H45.995z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.83 261.014c.853.853 1.265 1.934 1.92 2.901.17-.185.227-.412.398-.597l-2.318-2.304ZM165.561 259.464a72.06 72.06 0 0 0-48.455-18.702h-7.111v-85.59l60.914-25.244c-7.14-4.182-15.915-5.12-23.822-1.92l-65.536 27.164v85.59h7.111a72.13 72.13 0 0 1 48.455 18.702l31.502 28.586c7.41 7.197 19.228 7.112 26.539-.184l.185-.185c.213-.214.284-.512.497-.74l-30.279-27.477ZM239.986 223.709h-.014l13.027 13.028h.015l-13.028-13.028Z",
    style: {
      fill: "#dcb400",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.298 118.948a26.927 26.927 0 0 0-22.428.782l-1.849.925 72.974 29.852v73.188l-25.557 17.067-5.22 1.166 13.099 3.442 20.579-4.623 25.558-17.066v-73.188l-77.156-31.545Z",
    style: {
      fill: "#d5dbe1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.607 253.746c-7.538 0-14.991-2.872-20.68-8.561l-13.937-13.938 15.089-15.09 13.938 13.938c3.214 3.2 8.448 3.2 11.648 0 3.684-3.755 3.684-9.06.498-12.317l-40.59-40.576 15.09-15.089 40.675 40.661c11.335 11.563 11.335 30.265.071 41.756-6.172 6.173-14.037 9.216-21.802 9.216ZM77.493 145.375l27.373-11.347 8.165 19.699-27.373 11.347-8.165-19.699ZM176.669 149.327l-7.78-7.78c-4.707-4.721-11.69-6.158-17.806-3.669l-38.052 15.849-8.163-19.698 38.137-15.891a37.74 37.74 0 0 1 40.974 8.32l7.765 7.779-15.075 15.09Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.958 188.31a28.796 28.796 0 0 1-20.367-8.462c-6.627-6.628-9.557-15.716-8.064-24.974 1.494-9.245 7.154-16.953 15.531-21.149l47.019-23.538c9.813-4.892 21.234-5.29 31.317-1.081l77.07 31.531-8.078 19.755-77.141-31.559a16.337 16.337 0 0 0-13.625.441l-47.005 23.537c-2.176 1.081-3.64 3.087-4.039 5.49a7.394 7.394 0 0 0 2.091 6.471 7.488 7.488 0 0 0 8.647 1.394l41.785-21.035 9.6 19.058-41.771 21.035a28.98 28.98 0 0 1-12.97 3.086ZM212.082 280.555c-7.893 0-15.317-3.086-20.907-8.661l-17.351-17.351 15.09-15.09 17.351 17.351c3.115 3.115 8.534 3.115 11.634 0a8.143 8.143 0 0 0 2.418-5.817c0-2.19-.854-4.266-2.418-5.817l-13.924-13.923 15.09-15.09 13.938 13.924c5.589 5.603 8.661 13.013 8.661 20.906 0 7.908-3.072 15.318-8.661 20.907-5.589 5.575-13.013 8.661-20.921 8.661.014 0 .014 0 0 0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.718 303.979c-7.439 0-14.848-2.759-20.537-8.305l-31.218-28.317a61.358 61.358 0 0 0-41.287-15.943h-7.111v-21.333h7.111c20.594 0 40.348 7.623 55.623 21.475l31.488 28.587c3.484 3.385 8.676 3.356 11.833.185 1.749-1.75 2.603-3.826 2.603-6.016a8.19 8.19 0 0 0-2.404-5.817l-13.938-13.938 15.09-15.09 13.938 13.938c5.589 5.589 8.661 12.999 8.661 20.907 0 7.907-3.072 15.317-8.661 20.906-5.888 5.846-13.554 8.761-21.191 8.761ZM289.607 256.008c-4.039 0-8.092-.669-12.003-2.006l-25.415-8.689 6.898-20.196 25.415 8.69c5.504 1.906 11.633.683 16-3.143l22.229-23.14 15.36 14.806-22.898 23.765c-7.41 6.556-16.483 9.913-25.586 9.913Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.995 263.389h-35.556c-5.888 0-10.666-4.779-10.666-10.667V131.834c0-5.888 4.778-10.667 10.666-10.667h35.556c5.888 0 10.667 4.779 10.667 10.667v120.888c0 5.888-4.779 10.667-10.667 10.667Zm-24.889-21.333h14.222V142.5h-14.222v99.556ZM81.551 263.389H45.995c-5.888 0-10.667-4.779-10.667-10.667V131.834c0-5.888 4.779-10.667 10.667-10.667h35.556c5.888 0 10.666 4.779 10.666 10.667v120.888c0 5.888-4.778 10.667-10.666 10.667Zm-24.889-21.333h14.222V142.5H56.662v99.556Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/trust.af4b86261b19af3cc980ee73965b6631.svg";
export { ForwardRef as ReactComponent };